var _effectorFileName = "/src/page-content/cases/components/cases-block/cases-block.tsx";
import { STUDENTS_CASES } from '@/widgets/layouts/main/students-cases/constants/cases-list';
import { RevealAnimation } from '@/shared/components/animation/reveal';
import { Article } from '@/shared/components/article';
import { BentoCard, BentoGrid } from '@/shared/components/bento-grid';
export const CasesBlock = () => {
  return <Article>
      <BentoGrid className="grid-cols-1 sm:grid-cols-2 lg:grid-cols-3">
        {STUDENTS_CASES.map((studentCase, index) => {
        return <RevealAnimation key={index} className={`${studentCase.className} z-20`}>
              <BentoCard {...studentCase} />
            </RevealAnimation>;
      })}
      </BentoGrid>
    </Article>;
};